<template>
  <div id="app">
    <NavComponent :routerName="routerName" />
    <router-view />
  </div>
</template>

<script>
import NavComponent from "@/components/Nav.vue";
export default {
  components: {
    NavComponent,
  },
  data() {
    return {
      routerName: "",
    };
  },
  watch: {
    $route: function (v) {
      this.routerName = v.path;
    },
  },
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none;
  color: #000;
}

</style>
